module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('headers', {
    attrs: {
      "navNum": _vm.navNum,
      "username": _vm.username
    }
  }), _c('div', {
    staticClass: "layout-wrapper"
  }, [_c('layout', [_c('template', {
    slot: "page"
  }, [_c('h2', [_vm._v("应用创建")]), _c('el-row', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    ref: "appForm",
    attrs: {
      "model": _vm.appForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "应用名称",
      "prop": "appName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "不超过20个字符"
    },
    model: {
      value: (_vm.appForm.appName),
      callback: function($$v) {
        _vm.$set(_vm.appForm, "appName", $$v)
      },
      expression: "appForm.appName"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "应用分类",
      "prop": "appType"
    }
  }, [_c('el-radio-group', {
    staticClass: "radio-group",
    model: {
      value: (_vm.appForm.appType),
      callback: function($$v) {
        _vm.$set(_vm.appForm, "appType", $$v)
      },
      expression: "appForm.appType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("游戏")]), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("应用")])], 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "应用图片",
      "prop": "appPicture"
    }
  }, [_c('el-upload', {
    ref: "selectImg",
    staticClass: "avatar-uploader avatar-uploader",
    attrs: {
      "action": "https://v0.api.upyun.com/one-click-login",
      "data": _vm.imgParams,
      "accept": "image/jpg,image/png",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.onBeforeUpload
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon",
    attrs: {
      "src": _vm.imageUrl
    }
  })])], 1), _c('p', {
    staticClass: "list-group content-description"
  }, [_vm._v("请上传应用图片，支持 jpg、png 格式，且不超过3M。")]), _c('el-form-item', {
    attrs: {
      "label": "应用介绍",
      "prop": "appIntroduction"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "不超过200个字符"
    },
    model: {
      value: (_vm.appForm.appIntroduction),
      callback: function($$v) {
        _vm.$set(_vm.appForm, "appIntroduction", $$v)
      },
      expression: "appForm.appIntroduction"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "应用平台",
      "prop": "appPlatform"
    }
  }, [_c('el-checkbox-group', {
    staticClass: "radio-group",
    model: {
      value: (_vm.appForm.appPlatform),
      callback: function($$v) {
        _vm.$set(_vm.appForm, "appPlatform", $$v)
      },
      expression: "appForm.appPlatform"
    }
  }, [_c('el-checkbox-button', {
    key: "ios",
    attrs: {
      "label": "ios"
    }
  }, [_vm._v("IOS 平台")]), _c('el-checkbox-button', {
    key: "android",
    attrs: {
      "label": "android"
    }
  }, [_vm._v("Android 平台")])], 1)], 1), (_vm.appForm.appPlatform.indexOf('ios') !== -1) ? _c('el-form-item', {
    staticClass: "platform-item",
    attrs: {
      "label": "Bundle ID",
      "prop": "BundleId"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入 Bundle ID"
    },
    model: {
      value: (_vm.appForm.BundleId),
      callback: function($$v) {
        _vm.$set(_vm.appForm, "BundleId", $$v)
      },
      expression: "appForm.BundleId"
    }
  }), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "IOS 应用的唯一标识。例:com.upyun.app",
      "placement": "right"
    }
  }, [_c('i', {
    staticClass: "el-icon-information"
  })])], 1) : _vm._e(), (_vm.appForm.appPlatform.indexOf('android') !== -1) ? _c('el-form-item', {
    staticClass: "platform-item",
    attrs: {
      "label": "应用签名",
      "prop": "androidSignature"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入应用签名"
    },
    model: {
      value: (_vm.appForm.androidSignature),
      callback: function($$v) {
        _vm.$set(_vm.appForm, "androidSignature", $$v)
      },
      expression: "appForm.androidSignature"
    }
  }), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "格式: 32 位数（仅支持数字+小写英文）。",
      "placement": "right"
    }
  }, [_c('i', {
    staticClass: "el-icon-information"
  })])], 1) : _vm._e(), (_vm.appForm.appPlatform.indexOf('android') !== -1) ? _c('el-form-item', {
    staticClass: "platform-item",
    attrs: {
      "label": "应用包名",
      "prop": "androidPackageName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入应用包名"
    },
    model: {
      value: (_vm.appForm.androidPackageName),
      callback: function($$v) {
        _vm.$set(_vm.appForm, "androidPackageName", $$v)
      },
      expression: "appForm.androidPackageName"
    }
  }), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "例: com.upyun.app",
      "placement": "right"
    }
  }, [_c('i', {
    staticClass: "el-icon-information"
  })])], 1) : _vm._e(), _c('el-form-item', {
    attrs: {
      "label": "RSA 公钥",
      "prop": "RSAPublicKey"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入 RSA 公钥"
    },
    model: {
      value: (_vm.appForm.RSAPublicKey),
      callback: function($$v) {
        _vm.$set(_vm.appForm, "RSAPublicKey", $$v)
      },
      expression: "appForm.RSAPublicKey"
    }
  }), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "1024bit pkcs#8格式，用于访问接口验签。",
      "placement": "right"
    }
  }, [_c('i', {
    staticClass: "el-icon-information"
  })])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "submit-groups"
  }, [_c('sms_button', {
    staticClass: "submit-btn",
    nativeOn: {
      "click": function($event) {
        return _vm.goBack($event)
      }
    }
  }, [_vm._v("取消")]), _c('sms_button', {
    staticClass: "submit-btn",
    attrs: {
      "type": "major"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.createApp($event)
      }
    }
  }, [_vm._v("提交")])], 1)])], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-079719b5"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/createApplication.vue
// module id = 1000
// module chunks = 1